module.exports = __webpack_public_path__ + "static/media/star.34037755.svg";